import { Component } from 'react'
import PropTypes from 'prop-types'

class CurrentIndexFaC extends Component {
  static propTypes = {
    infinite: PropTypes.bool,
    totalItems: PropTypes.number.isRequired,
    onCurrentIndexChanged: PropTypes.func
  }

  static defaultProps = {
    infinite: false
  }

  state = {
    currentIndex: 0
  }

  componentWillReceiveProps(nextProps) {
    if (!isNaN(nextProps.currentIndex)) {
      this.setState({
        currentIndex: nextProps.currentIndex
      })
    }
  }

  render() {
    const { children } = this.props
    const { currentIndex } = this.state

    return children({
      currentIndexProps: {
        prevHandler: this._prevHandler,
        nextHandler: this._nextHandler,
        setIndex: this._setIndex
      },
      currentIndex
    })
  }

  /**
   * update the position of the index
   * when index is not in infinite (loop) mode, return if at first index
   * when index is in infinite (loop) mode, move to last index if at first index
   *  otherwise, move to previous index
   */
  _prevHandler = e => {
    e.preventDefault()
    const { infinite, totalItems, basicPaginationEnabled } = this.props
    const { currentIndex } = this.state

    if (!infinite && currentIndex === 0 && !basicPaginationEnabled) {
      return
    }
    this._setIndex(currentIndex === 0 ? totalItems - 1 : currentIndex - 1, 'prev')
  }

  /**
   * update the position of the index
   * when index is not in infinite (loop) mode, return if at last index
   * when index is in infinite (loop) mode, move to first index if at last index
   *  otherwise, move to next index
   */
  _nextHandler = e => {
    e.preventDefault()
    const { infinite, totalItems, basicPaginationEnabled } = this.props
    const { currentIndex } = this.state

    if (!infinite && currentIndex + 1 === totalItems && !basicPaginationEnabled) {
      return
    }

    this._setIndex(currentIndex === totalItems - 1 ? 0 : currentIndex + 1, 'next')
  }

  /**
   * navigate to the supplied index
   */
  _setIndex = (idx, buttonClicked) => {
    const { onCurrentIndexChanged } = this.props
    const { currentIndex } = this.state

    if (this.props.basicPaginationEnabled && this.props.totalItems === 1) {
      if (this.props.onCurrentIndexChanged) {
        this.props.onCurrentIndexChanged(this.state.currentIndex, buttonClicked)
      }
    }

    if (idx === currentIndex) {
      return
    }

    this.setState(
      () => ({
        currentIndex: idx
      }),
      () => {
        if (onCurrentIndexChanged) {
          onCurrentIndexChanged(this.state.currentIndex, buttonClicked)
        }
      }
    )
  }
}

export default CurrentIndexFaC
